import { APP_WEBSOCKET_HOST } from '@/utils/constants'

export default {
  install(Vue) {
    const socket = new WebSocketService()

    Vue.prototype.$webSocket = socket
  },
}

class WebSocketService {
  constructor() {
    this.sockets = new Map() // storeId → WebSocket (샵인샵 다중 매장 구독)
    this.listeners = new Set()
  }

  /**
   * 주문알림 WebSocket 구독.
   * @param storeIds 단일 storeId(string) 또는 storeId 배열 — 대표 매장 로그인 시 그룹 전체
   */
  init(storeIds) {
    const ids = (Array.isArray(storeIds) ? storeIds : [storeIds]).filter(Boolean)

    ids.forEach((storeId) => this.connect(storeId))
  }

  connect(storeId) {
    if (this.sockets.has(storeId)) return

    const websocketHost = APP_WEBSOCKET_HOST
    const url = `${websocketHost}/${storeId}/1`

    console.log('WebSocket connecting to:', url)

    const socket = new WebSocket(url)

    socket.onopen = () => console.log('WebSocket connected:', storeId)
    socket.onmessage = (event) => this.notifyListeners(event.data, storeId)
    socket.onclose = () => {
      this.sockets.delete(storeId)
    }
    socket.onerror = (error) => console.error('WebSocket error:', storeId, error)

    this.sockets.set(storeId, socket)
  }

  addListener(callback) {
    this.listeners.add(callback)
  }

  removeListener(callback) {
    this.listeners.delete(callback)
  }

  notifyListeners(data, storeId) {
    this.listeners.forEach((callback) => callback(data, storeId))
  }

  disconnect() {
    this.sockets.forEach((socket) => {
      try {
        socket.close()
      } catch (e) {}
    })
    this.sockets.clear()
  }
}
